
import { NavItem } from '../types';
import { Phone } from 'lucide-react';

const dialerItems: NavItem[] = [
  {
    title: 'Dialer',
    path: '/app/dialer',
    icon: Phone,
    requiredPermissions: ['dialer.read'],
  }
];

export default dialerItems;
